import React from 'react';
import {
  Container,
  Typography,
  Box,
  Paper,
  Tabs,
  Tab,
} from '@mui/material';
import FileUpload from '../../components/FileUpload/FileUpload';
import DocumentList from '../../components/DocumentList/DocumentList';
import AppealsList from '../../components/AppealsList/AppealsList';

const DocumentsPage = () => {
  const [activeTab, setActiveTab] = React.useState(0);

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  return (
    <Container maxWidth="lg">
      <Box sx={{ my: 4 }}>
        <Typography variant="h4" component="h1" gutterBottom>
          Documents
        </Typography>

        <Paper sx={{ width: '100%', mb: 3 }}>
          <Tabs
            value={activeTab}
            onChange={handleTabChange}
            indicatorColor="primary"
            textColor="primary"
            centered
          >
            <Tab label="My Documents" />
            <Tab label="Appeal Letters" />
            <Tab label="Upload New" />
          </Tabs>
        </Paper>

        {activeTab === 0 ? (
          <DocumentList />
        ) : activeTab === 1 ? (
          <AppealsList />
        ) : (
          <Box sx={{ mt: 4 }}>
            <Paper sx={{ p: 3, mb: 3 }}>
              <Typography variant="body1" color="textSecondary" paragraph>
                Upload a new document by entering the Patient ID and Provider ID,
                then drag and drop or select a PDF file.
              </Typography>
            </Paper>
            <FileUpload />
          </Box>
        )}
      </Box>
    </Container>
  );
};

export default DocumentsPage;
